import React, { Component } from "react";

import "./activityIcon.css";

export default class ActivityIcon extends Component {
  render() {
    const { ballCount } = this.props;

    const balls = [];
    for (let i = 0; i < ballCount; i++) {
      balls.push(<div key={i} id={"ball" + i} className="ball" />);
    }

    return <div className="ball-container">{balls}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/utils/activityIcon.js